module.exports = __webpack_public_path__ + "img/project10_1.png.05c97557.webp";